import React from "react";
import { Languages } from "lucide-react";
import { useTranslation } from "react-i18next";
import {
  DropdownMenu,
  DropdownMenuCheckboxItem,
  DropdownMenuContent,
  DropdownMenuLabel,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { useTranslationPreferences } from "@/components/pages/chats/hooks/useTranslationPreferences";

export const TranslationSettingsSelect = () => {
  const { t } = useTranslation();
  const { preferences, updatePreferences } = useTranslationPreferences();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          type="button"
          className="flex size-9 items-center justify-center rounded-lg border border-violet-300 bg-white text-[#7d7aa5] shadow-sm transition-colors hover:border-violet-400 hover:bg-violet-50"
          aria-label={t("chats.translation.settings")}
          title={t("chats.translation.settings")}
        >
          <Languages className="size-5" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align="end"
        sideOffset={8}
        className="w-72 rounded-lg p-1.5 shadow-lg"
      >
        <DropdownMenuLabel className="text-muted-foreground px-2 py-1.5 text-xs font-semibold">
          {t("chats.translation.settings")}
        </DropdownMenuLabel>
        <DropdownMenuCheckboxItem
          className="rounded-md py-2 pr-2 pl-8 text-sm leading-5"
          checked={preferences.neverTranslateEnglish}
          onCheckedChange={(neverTranslateEnglish) =>
            updatePreferences({ neverTranslateEnglish })
          }
        >
          {t("chats.translation.neverTranslateEnglish")}
        </DropdownMenuCheckboxItem>
        <DropdownMenuCheckboxItem
          className="rounded-md py-2 pr-2 pl-8 text-sm leading-5"
          checked={preferences.showGuestOriginalMessages}
          onCheckedChange={(showGuestOriginalMessages) =>
            updatePreferences({ showGuestOriginalMessages })
          }
        >
          {t("chats.translation.showGuestOriginalMessages")}
        </DropdownMenuCheckboxItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
